import styled from 'styled-components';

// Fixed over the top of the page (above TopBar, z-index 100) and taking no space
// in the layout, so appearing or closing never moves page content.
export const Wrapper = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  height: 8rem;
  padding: 0 1rem 0 0.5rem;
  background: #f4f4f4;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
`;

export const CloseButton = styled.button`
  flex: none;
  width: 3.2rem;
  height: 3.2rem;
  padding: 0;
  border: 0;
  background: none;
  color: #888;
  font-size: 2.4rem;
  line-height: 1;
  cursor: pointer;
`;

export const Icon = styled.img`
  flex: none;
  width: 5.7rem;
  height: 5.7rem;
  margin-right: 1rem;
  border-radius: 1rem;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
  line-height: 1.3;
`;

export const Title = styled.div`
  overflow: hidden;
  color: #333;
  font-size: 1.4rem;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Author = styled.div`
  color: #666;
  font-size: 1.2rem;
`;

export const Description = styled.div`
  color: #666;
  font-size: 1.2rem;
`;

export const ViewButton = styled.a`
  flex: none;
  margin-left: 1rem;
  padding: 0.6rem 1.4rem;
  border-radius: 0.4rem;
  background: ${p => p.theme.primaryColor};
  color: #fff;
  font-size: 1.4rem;
  font-weight: bold;
  text-decoration: none;
`;
